import { appendChildren, createEl } from './utils';
import PathUpdate from './PathUpdate';
import intro_html from '../Views/intro/index.cshtml';
import Lottie from 'lottie-web';


export default class Intro {
  constructor(state, airplane) {
    this.state = state;
	  this.el = createEl('div', { className: 'airplane-intro', innerHTML: intro_html });

	  console.log("intro");

	  document.body.className += ' intro_popup';

	let _this = this;
	
	let intro1 = this.el.querySelector('div#intro1');
	let intro2 = this.el.querySelector('div#intro2');
	let ani = this.el.querySelector('.lottie-player');

	/// intro sequence
	  let btn_intro_sequ_next = this.el.querySelector('button#btn_intro_sequ_next');
	  let btn_intro_sequ_ok = this.el.querySelector('button#btn_intro_sequ_ok');

	  let pi_link_btn = this.el.querySelector('.linkPi');




	
	this._path = PathUpdate.getInstance();	    
	this._path.update('Start');	
	
	this.lottie = Lottie.loadAnimation({
		  container: ani, 
		  renderer: 'svg',
		  loop: false,
		  autoplay: false,
		  path: '/assets/ani/HangerClosedFrameIn.json'
	});


	  //pi_link_btn.addEventListener('click', function (e) {

		 // _this.state.popup = "Pi";

		 
			//  document.querySelector(".intro-content").classList.add("hide_intro");



	  //});

	btn_intro_sequ_next.addEventListener('click', function(e){
	
		//intro1.classList.add('hidden');

		//intro2.classList.remove('hidden');
				
		//airplane.cockpit.intructions(true); /// turn on lights
		
		//_this.lottie.goToAndPlay(0);
		
		//_this._path.update('Intro2');

		window.open('http://euonc21.astellaslive.com/', '_blank');
		 
	});



	  btn_intro_sequ_ok.addEventListener('click', function (e) {

		  intro1.classList.add('hidden');

		  intro2.classList.remove('hidden');

		  airplane.cockpit.intructions(true); /// turn on lights

		  _this.lottie.goToAndPlay(0);

		  _this._path.update('Intro2');

		  document.querySelector("#close_btn_populationCisplatin").click();


	  });

	
	/// start button
	let btn_intro_sequ_start = this.el.querySelector('button#btn_intro_sequ_start');
	
	  btn_intro_sequ_start.addEventListener('click', function (e) {
		  document.body.classList.remove("intro_popup"); 
		 _this.state.flow = 'takeoff';
		  _this.el.classList.add('hidden');

		  airplane.cockpit.intructions();

		
		  //document.querySelector(".populationCisplatinView").classList.remove('populationCisplatinView');
		  //close_btn_populationCisplatin


		  //_this.state.flow = 'null';
		   
		  

		  //for (var i = 0; i < viewsHidden.length; i++) {
			 // viewsHidden[i].classList.add('hidden');  
    //      }

	});

  }

}
